<template>
  <div class="article-detail-page">
    <NavBar />
    
    <div class="page-wrapper">
      <!-- 面包屑 -->
      <div class="breadcrumb-bar">
        <span class="crumb" @click="$router.push('/')">首页</span>
        <span class="crumb-sep">&gt;</span>
        <span class="crumb" v-if="article.category_id" @click="$router.push(`/articles/${article.category_id}`)">{{ categoryName }}</span>
        <span class="crumb-sep" v-if="article.category_id">&gt;</span>
        <span class="crumb active">正文</span>
      </div>
      
      <div class="content-layout">
        <!-- 左侧文章 -->
        <main class="article-card">
          <!-- 标题区 -->
          <header class="article-header">
            <h1 class="title">{{ article.title }}</h1>
            <div class="meta-line">
              <span class="meta-time">{{ formatTime(article.createtime) }}</span>
              <span class="meta-cat" v-if="categoryName">{{ categoryName }}</span>
            </div>
          </header>
          
          <!-- 封面 -->
          <div class="cover-box" v-if="article.cover_url">
            <img :src="article.cover_url" :alt="article.title" />
          </div>
          
          <!-- 正文 -->
          <section class="article-content" v-html="article.content"></section>
        </main>
        
        <!-- 右侧边栏 -->
        <aside class="aside-panel">
          <!-- 联系信息 -->
          <div class="info-box" v-if="article.contact_name || article.contact_phone">
            <div class="box-title">联系信息</div>
            <div class="info-row" v-if="article.contact_name">
              <span class="info-label">联系人</span>
              <span class="info-value">{{ article.contact_name }}</span>
            </div>
            <div class="info-row" v-if="article.contact_phone">
              <span class="info-label">电话</span>
              <span class="info-value tel">{{ article.contact_phone }}</span>
            </div>
          </div>
          
          <!-- 导航 -->
          <div class="nav-box">
            <div class="box-title">快捷导航</div>
            <div class="nav-btn" @click="$router.push('/')">返回首页</div>
            <div class="nav-btn" @click="$router.back()">返回上页</div>
          </div>
        </aside>
      </div>
    </div>
    
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import { getArticleDetail, getArticleCategories } from '@/api/index.js'

export default {
  name: 'ArticleDetail',
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      article: {},
      categoryName: ''
    }
  },
  mounted() {
    this.loadArticleDetail()
  },
  methods: {
    async loadArticleDetail() {
      const id = this.$route.params.id
      if (!id) {
        this.$message.error('文章ID不存在')
        this.$router.push('/')
        return
      }
      
      try {
        const result = await getArticleDetail(id)
        if (result.code === 1 && result.data) {
          this.article = result.data
          
          // 获取分类名称
          if (this.article.category_id) {
            this.loadCategoryName()
          }
        } else {
          this.$message.error(result.msg || '文章不存在')
          this.$router.push('/')
        }
      } catch (error) {
        console.error('加载文章详情失败:', error)
        this.$message.error('加载失败，请稍后重试')
      }
    },
    async loadCategoryName() {
      try {
        const result = await getArticleCategories()
        if (result.code === 1 && result.data) {
          const category = result.data.find(cat => cat.id === this.article.category_id)
          this.categoryName = category ? category.name : '文章资讯'
        }
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}年${month}月${day}日`
    }
  }
}
</script>

<style scoped>
.article-detail-page {
  min-height: 100vh;
  background: #f0f2f5;
}

.page-wrapper {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 16px 50px;
}

/* 面包屑 */
.breadcrumb-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 14px;
  color: #666;
}

.crumb {
  cursor: pointer;
}

.crumb:hover {
  color: #1890ff;
}

.crumb.active {
  color: #333;
  cursor: default;
}

.crumb-sep {
  color: #ccc;
}

/* 内容布局 */
.content-layout {
  display: flex;
  gap: 20px;
}

/* 文章卡片 */
.article-card {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.article-header {
  padding: 24px 24px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #222;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.meta-line {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #999;
}

.meta-cat {
  padding: 2px 8px;
  background: #f5f5f5;
  border-radius: 3px;
}

/* 封面 */
.cover-box {
  padding: 0 24px;
}

.cover-box img {
  width: 100%;
  border-radius: 4px;
  display: block;
}

/* 正文 */
.article-content {
  padding: 24px;
  font-size: 15px;
  line-height: 1.8;
  color: #333;
}

.article-content :deep(p) {
  margin-bottom: 16px;
}

.article-content :deep(h2) {
  font-size: 20px;
  font-weight: 600;
  color: #222;
  margin: 28px 0 14px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.article-content :deep(h3) {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 22px 0 12px 0;
}

.article-content :deep(img) {
  max-width: 100%;
  border-radius: 4px;
  margin: 16px 0;
}

.article-content :deep(ul),
.article-content :deep(ol) {
  margin: 14px 0;
  padding-left: 24px;
}

.article-content :deep(li) {
  margin-bottom: 8px;
}

.article-content :deep(blockquote) {
  margin: 16px 0;
  padding: 12px 16px;
  background: #fafafa;
  border-left: 3px solid #ddd;
  color: #666;
}

.article-content :deep(code) {
  padding: 2px 6px;
  background: #f5f5f5;
  border-radius: 3px;
  font-size: 13px;
}

.article-content :deep(pre) {
  margin: 16px 0;
  padding: 16px;
  background: #282c34;
  color: #abb2bf;
  border-radius: 4px;
  overflow-x: auto;
}

.article-content :deep(pre code) {
  background: transparent;
  padding: 0;
}

.article-content :deep(table) {
  width: 100%;
  margin: 16px 0;
  border-collapse: collapse;
}

.article-content :deep(th),
.article-content :deep(td) {
  padding: 10px 12px;
  border: 1px solid #e8e8e8;
  text-align: left;
}

.article-content :deep(th) {
  background: #fafafa;
  font-weight: 600;
}

.article-content :deep(a) {
  color: #1890ff;
}

.article-content :deep(a:hover) {
  text-decoration: underline;
}

/* 侧边栏 */
.aside-panel {
  width: 280px;
  flex-shrink: 0;
}

.info-box,
.nav-box {
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}

.box-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
}

.info-label {
  color: #999;
}

.info-value {
  color: #333;
}

.info-value.tel {
  color: #1890ff;
}

.nav-btn {
  display: block;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  color: #666;
  background: #fafafa;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-btn:last-child {
  margin-bottom: 0;
}

.nav-btn:hover {
  background: #1890ff;
  color: #fff;
}

/* 响应式 */
@media (max-width: 768px) {
  .content-layout {
    flex-direction: column;
  }
  
  .aside-panel {
    width: 100%;
  }
  
  .article-header {
    padding: 16px;
  }
  
  .title {
    font-size: 18px;
  }
  
  .cover-box {
    padding: 0 16px;
  }
  
  .article-content {
    padding: 16px;
    font-size: 14px;
  }
}
</style>
